<template>
  <div>
    <a-card :title="title" :bordered="false">
      <template slot="extra">
        <div style="display: flex; align-items: center; gap: 10px;">
          <a-select v-model="localStatFilter" style="width: 140px" @change="handleFilter" v-if="showFilter">
            <a-select-option value="30-days">30 Days</a-select-option>
            <a-select-option value="60-days">60 Days</a-select-option>
            <a-select-option value="365-days">365 Days</a-select-option>
            <a-select-option value="today">Today</a-select-option>
            <a-select-option value="month-to-date">Month To Date</a-select-option>
            <a-select-option value="quarter-to-date">Quarter To Date</a-select-option>
            <a-select-option value="year-to-date">Year To Date</a-select-option>
          </a-select>
          <a-divider type="vertical"/>
          <a-button type="default" shape="circle" icon="sync" size="small" @click="filterStatValue('refresh')"/>
        </div>
      </template>
      <div style="display: flex;">
        <div
            style="width: 15%; background: #7171ff; height: 40px; border-radius: 5px; display: flex; justify-content: center; align-items: center; margin-right: 15px">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" width="20px"
               height="20px" style="color: white" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"/>
          </svg>
        </div>
        <div style="display: flex; flex-direction: column; justify-content: center;">
          <h3 style="margin: 0;"> {{ statValue.count }} </h3>
          <span v-if="showFilter">
                        <svg v-if="statValue.type === 'increase'" xmlns="http://www.w3.org/2000/svg" fill="none"
                             viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                             style="width: 16px; height: 16px; color: green; vertical-align: middle;font-weight: 600;">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                             stroke-width="1.5" stroke="currentColor"
                             style="width: 16px; height: 16px; color: red; vertical-align: middle;font-weight: 600;">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"/>
                        </svg>
                        {{ parseFloat(statValue.percentage).toFixed(2) }} % {{ statValue.type }}
                      </span>
        </div>
      </div>
    </a-card>
  </div>
</template>
<script>
import number from "ant-design-vue/lib/statistic/Number";

export default {
  name: 'StatCardComponent',
  computed: {
    number() {
      return number
    }
  },
  props: {
    filterStatValue: {type: Function},
    statValue: {
      type: Object,
      required: true
    },
    statFilter: {},
    title: {},
    showFilter: {
      default: true
    }
  },
  data() {
    return {
      localStatFilter: this.statFilter, // Initialize local data property
    };
  },
  watch: {
    statFilter(newValue) {
      this.localStatFilter = newValue; // Update local property if prop changes
    },
  },
  methods: {
    handleFilter(action) {
      this.$emit('update-filter', this.localStatFilter);
      if (this.filterStatValue) {
        this.filterStatValue(action);
      }
    },
  }
}
</script>